const CUSTOM_SCRIPT_ATTR = "data-knopka-custom-script";
const MAX_SCRIPTS_LEN = 12_000;

const DISALLOWED_SCRIPT_MARKUP =
  /<\s*(body|html|iframe|object|embed|form|link|meta|style|base|svg|img)\b|<\/\s*(body|html)\s*>/i;

export function sanitizeCustomScripts(scripts: string | null | undefined): string | null {
  const text = (scripts || "").trim();
  if (!text) return null;
  if (text.length > MAX_SCRIPTS_LEN) {
    throw new Error(`custom scripts exceed ${MAX_SCRIPTS_LEN} characters`);
  }
  if (DISALLOWED_SCRIPT_MARKUP.test(text)) {
    throw new Error("custom scripts contain disallowed HTML tags");
  }
  return text;
}

function copyScriptElement(source: HTMLScriptElement): HTMLScriptElement {
  const script = document.createElement("script");
  for (const attr of Array.from(source.attributes)) {
    script.setAttribute(attr.name, attr.value);
  }
  script.setAttribute(CUSTOM_SCRIPT_ATTR, "1");
  if (source.textContent) {
    script.textContent = source.textContent;
  }
  return script;
}

/** Parse saved HTML and append executable <script> nodes at the end of <body>. */
export function applyKnopkaBookingPageCustomScripts(scripts: string | null | undefined): void {
  if (typeof document === "undefined") return;
  clearKnopkaBookingPageCustomScripts();

  const html = (scripts || "").trim();
  if (!html) return;

  const container = document.createElement("div");
  container.innerHTML = html;
  const scriptNodes = container.querySelectorAll("script");
  if (!scriptNodes.length) return;

  scriptNodes.forEach((node) => {
    document.body.appendChild(copyScriptElement(node));
  });
}

export function clearKnopkaBookingPageCustomScripts(): void {
  if (typeof document === "undefined") return;
  document.querySelectorAll(`script[${CUSTOM_SCRIPT_ATTR}="1"]`).forEach((node) => node.remove());
}
